module.exports = __webpack_public_path__ + "static/media/Transaction report.7c8dee0c.png";